import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

import { STORAGE_KEYS } from '@/atoms/storageKeys';

export const PLAN_RESOURCE_DEBUG_MOCK_ITEM_ID = 'mock-plan-resource-error';

export type PlanResourceDebugMockScenario =
  | 'unavailable'
  | 'unavailable_with_ids'
  | 'missing_resource_id'
  | 'missing_reference'
  | 'missing_both';

export interface PlanResourceDebugMockState {
  enabled: boolean;
  scenario: PlanResourceDebugMockScenario;
}

export const DEFAULT_PLAN_RESOURCE_DEBUG_MOCK: PlanResourceDebugMockState = {
  enabled: false,
  scenario: 'unavailable',
};

export const PLAN_RESOURCE_DEBUG_MOCK_SCENARIOS: {
  id: PlanResourceDebugMockScenario;
  label: string;
  description: string;
}[] = [
  {
    id: 'unavailable',
    label: 'Unavailable (no resource)',
    description:
      'XP available=false and strips resource — plan-list warning + missing_fields both.',
  },
  {
    id: 'unavailable_with_ids',
    label: 'Unavailable (IDs present)',
    description:
      'XP available=false but keeps resource/reference IDs — empty missing_fields.',
  },
  {
    id: 'missing_resource_id',
    label: 'Missing resource ID',
    description: 'available=true with empty resource id; reference intact.',
  },
  {
    id: 'missing_reference',
    label: 'Missing reference',
    description: 'available=true with resource id but no references.',
  },
  {
    id: 'missing_both',
    label: 'Missing both IDs',
    description: 'available=true with no resource on the document step.',
  },
];

export const planResourceDebugMockAtom = atomWithStorage(
  STORAGE_KEYS.PLAN_RESOURCE_DEBUG_MOCK,
  DEFAULT_PLAN_RESOURCE_DEBUG_MOCK,
  undefined,
  { getOnInit: true },
);

export const planResourceDebugMockEnabledAtom = atom(
  get => get(planResourceDebugMockAtom).enabled,
  (get, set, enabled: boolean) => {
    set(planResourceDebugMockAtom, {
      ...get(planResourceDebugMockAtom),
      enabled,
    });
  },
);
